const ACCESS_TOKEN_KEY = 'access_token';
import router from "@/router";
import store from "@/store";
import api from "@/api";


export async function requireAuth(to, from, next) {
    store.commit('setLoading', false);
    if (!isLoggedIn()) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    } else {
        let response = (await api.getUser());
        if (response.data) {
            let user = response.data.employe
            if (user.admin) {
                store.commit('setUser', user);
                next();
            } else {
                clearAccessToken();
                store.commit('setUser', undefined);
                router.push('/login');
            }
        } else {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    }
}

export function login(accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    router.push('/staff');
}

export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function logout() {
    clearAccessToken();
    store.commit('setUser', undefined);
    router.push('/login');
}

function clearAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function isLoggedIn() {
    return getAccessToken() !== null;
}